import { Component, Input, ViewEncapsulation } from '@angular/core';

const DEFAULT_RADIUS = 25;

@Component({
    selector: 'bv-loader',
    templateUrl: './bavel-loader.component.html',
    styleUrls: ['./bavel-loader.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class BavelLoaderComponent {
  @Input() public show!: boolean;

  @Input() public radius!: number;

  public get size(): string {
    this.radius = this.radius || DEFAULT_RADIUS;
    return (this.radius * 2) + 'px';
  }
}
